import React from "react";
import { profileData } from "../data/mock";
import { Separator } from "./ui/separator";
import { User, Target, TrendingUp, Zap } from "lucide-react";

const About = () => {
  const highlights = [
    {
      icon: Target,
      title: "Results-Driven",
      text: "Improved service performance to ~98% on-time, coordinating 450-550+ monthly loads across nationwide operations.",
    },
    {
      icon: TrendingUp,
      title: "Account Growth",
      text: "Supported major accounts including Lowe's, Medline, Nike, and Kimberly-Clark through strategic service execution.",
    },
    {
      icon: Zap,
      title: "Process Innovator",
      text: "Built Excel macros and automated reporting tools that saved 2+ hours per cycle and improved operational visibility.",
    },
  ];

  return (
    <section id="about" className="py-14 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12 lg:mb-16">
          <p className="text-sm font-medium text-teal-600 tracking-wide uppercase mb-2">
            About Me
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Professional Profile
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 lg:gap-16">
          {/* Summary text */}
          <div className="lg:col-span-3">
            <p className="text-base lg:text-lg text-slate-600 leading-relaxed">
              {profileData.summary}
            </p>
            <Separator className="my-8 bg-slate-100" />
            <div className="flex flex-wrap gap-x-8 gap-y-4 text-sm text-slate-500">
              <div className="flex items-center gap-2">
                <User size={15} className="text-teal-500" />
                <span>10+ Years in Supply Chain</span>
              </div>
              <div className="flex items-center gap-2">
                <Target size={15} className="text-teal-500" />
                <span>MBA, Supply Chain Management</span>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp size={15} className="text-teal-500" />
                <span>J.B. Hunt Transport Services</span>
              </div>
            </div>
          </div>

          {/* Highlight cards */}
          <div className="lg:col-span-2 space-y-4">
            {highlights.map((item, i) => (
              <div
                key={i}
                className="group flex gap-4 p-4 rounded-xl border border-slate-100 hover:border-teal-100 hover:bg-teal-50/30 transition-all duration-300"
              >
                <div className="w-9 h-9 rounded-lg bg-slate-50 group-hover:bg-teal-50 flex items-center justify-center text-slate-400 group-hover:text-teal-600 transition-all shrink-0">
                  <item.icon size={18} />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-slate-800">
                    {item.title}
                  </h3>
                  <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
